import React, { useState } from "react";

import {
  Alert,
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Stack,
  SwipeableDrawer,
  TextField,
  Typography,
} from "@mui/material";
import Selector from "../basics/Selector";
import { selectProductImage } from "../../Helpers/productSelector";
import {
  Add,
  Cancel,
  CheckBox,
  CheckBoxOutlineBlank,
} from "@mui/icons-material";
import { categoriesDict } from "../../Constants/products";
import { connectors } from "../../Dictionaries/connectors";

const powerKws = ["7.6", "9.6", "11"];

export default function AddProductToOrderDrawer({
  open,
  setOpen,
  product,
  cart,
  setCart,
}) {
  // ==========> Component States<==========
  //State for product quantity
  const [quantity, setQuantity] = useState(1);
  //State for company
  const [company, setCompany] = useState("");
  //State for specifications
  const [annotations, setAnnotations] = useState("");
  //State for specifications
  const [specifications, setSpecifications] = useState("");
  //State for connectorType
  const [connectorType, setConnectorType] = useState(0);
  //State for power Kw configuration
  const [powerKw, setPowerKw] = useState(0);
  //State for unit pre-tax price
  const [pretax, setPretax] = useState(0);
  //State for include price per unit
  const [useExistingUnitPrice, setUseExistingUnitPrice] = useState(false);
  //State for aditional info
  const [aditional, setAditional] = useState();
  //State for taxes
  const [includeTaxes, setIncludeTaxes] = useState(false);

  //Function to return the pretax price amount
  const pretaxPrice = () => {
    setUseExistingUnitPrice((prev) => {
      const newValue = !prev;
      setPretax(newValue ? product.priceInUSD * quantity : 0);
      return newValue;
    });
  };

  //Function to return the total price amount
  const totalPrice = () => {
    if (includeTaxes) {
      const taxes = pretax * 0.13;
      return Number(pretax) + Number(taxes);
    } else {
      return pretax;
    }
  };

  // ==========> Component <==========
  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {}}
    >
      <Box sx={{ overflowY: "auto", padding: "15px", flex: 1 }}>
        <Grid container justifyContent="center" spacing={1}>
          <Grid item xs={12} align="center">
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="center"
            >
              <Avatar
                sx={{ height: "100px", width: "100px" }}
                src={selectProductImage(product.productName)}
              />
              <Stack textAlign="left">
                <Typography variant="h6" fontWeight="bold">
                  {product.productName}
                </Typography>
                <Typography variant="body2">
                  {
                    categoriesDict.find((cat) => cat.name === product.type)
                      ?.description
                  }
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={10}>
            <Grid
              container
              justifyContent="center"
              sx={{ padding: "15px" }}
              textAlign="left"
              spacing={1}
            >
              <Grid item xs={12}>
                <Typography fontWeight="bold" color="secondary">
                  Información del producto
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack>
                  <Typography fontWeight="bold" variant="body2">
                    1. ¿Cuántas unidades desea producir?
                  </Typography>
                  <TextField
                    InputProps={{ inputProps: { min: 1 } }}
                    type="number"
                    value={quantity}
                    onChange={(e) => {
                      setQuantity(e.target.value);
                      setPretax(0);
                      setUseExistingUnitPrice(false);
                    }}
                    sx={{ width: "100%" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack>
                  <Typography fontWeight="bold" variant="body2">
                    2. Agencia o empresa que solicita
                  </Typography>
                  <TextField
                    value={company}
                    onChange={(e) => {
                      setCompany(e.target.value);
                    }}
                    sx={{ width: "100%" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack>
                  <Typography fontWeight="bold" variant="body2">
                    3. Especificaciones para los productos de esta orden
                  </Typography>
                  <TextField
                    value={specifications}
                    onChange={(e) => {
                      setSpecifications(e.target.value);
                    }}
                    sx={{ width: "100%" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack>
                  <Typography fontWeight="bold" variant="body2">
                    4. Anotaciones para esta orden
                  </Typography>
                  <TextField
                    value={annotations}
                    onChange={(e) => {
                      setAnnotations(e.target.value);
                    }}
                    sx={{ width: "100%" }}
                  />
                </Stack>
              </Grid>
              {product.type === "EV_STATION" && (
                <Grid item xs={12} md={6}>
                  <Stack>
                    <Typography fontWeight="bold" variant="body2">
                      5. Seleccione el tipo de conector para la estación de
                      carga
                    </Typography>
                    <Selector
                      value={connectorType}
                      handleChange={(e) => {
                        setConnectorType(e.target.value);
                      }}
                      content={connectors}
                      width="100%"
                    />
                  </Stack>
                </Grid>
              )}
              {product.type === "EV_STATION" && (
                <Grid item xs={12} md={6}>
                  <Stack>
                    <Typography fontWeight="bold" variant="body2">
                      6. Seleccione la potencia de la estación de carga (kW)
                    </Typography>
                    <Selector
                      value={powerKw}
                      handleChange={(e) => {
                        setPowerKw(e.target.value);
                      }}
                      content={powerKws}
                      width="100%"
                    />
                  </Stack>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={10}>
            <Grid
              container
              justifyContent="center"
              sx={{ padding: "15px" }}
              textAlign="left"
              spacing={1}
            >
              <Grid item xs={12}>
                <Typography fontWeight="bold" color="secondary">
                  Información de Facturación
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mb: 2 }}>
                <Alert severity="info">{`Complete la información de facturación para la orden y recuerde que el monto es del total de los productos de la orden. Por favor asegúrese de completar los espacios con la información correcta.`}</Alert>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Stack>
                  <Typography fontWeight="bold" variant="body2">
                    1. Monto total sin impuestos (USD)
                  </Typography>
                  <TextField
                    InputProps={{ inputProps: { min: 1 } }}
                    type="number"
                    value={pretax}
                    onChange={(e) => {
                      setPretax(e.target.value);
                    }}
                    sx={{ width: "100%" }}
                  />
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    sx={{ mt: 1 }}
                  >
                    <IconButton
                      onClick={() => {
                        pretaxPrice();
                      }}
                    >
                      {useExistingUnitPrice ? (
                        <CheckBox color="success" />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )}
                    </IconButton>
                    <Typography fontWeight="bold" variant="body2">
                      {`Calcular con base en
                      el precio unitario registrado en el
                      sistema ($${product.priceInUSD} por unidad) y la cantidad
                      solicitada`}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <IconButton
                      onClick={() => setIncludeTaxes((prev) => !prev)}
                    >
                      {includeTaxes ? (
                        <CheckBox color="success" />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )}
                    </IconButton>
                    <Typography fontWeight="bold" variant="body2">
                      Incluir IVA (13%)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack>
                  <Typography fontWeight="bold" variant="body2">
                    2. Información adicional de facturación
                  </Typography>
                  <TextField
                    value={aditional}
                    onChange={(e) => {
                      setAditional(e.target.value);
                    }}
                    sx={{ width: "100%" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack alignItems="center">
                  <Typography fontWeight="bold" variant="body2">
                    Monto Total
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">{`$${Number(
                    totalPrice()
                  ).toFixed(2)}`}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "10px" }}>
            <Stack direction="row" spacing={1} justifyContent="center">
              <Button
                size="small"
                variant="contained"
                color="error"
                sx={{ color: "white" }}
                endIcon={<Cancel />}
                onClick={() => setOpen(false)}
              >
                Cancelar
              </Button>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                disabled={quantity < 1}
                onClick={() => {
                  setCart((prevCart) => [
                    ...prevCart,
                    {
                      billing: {
                        pretax: pretax,
                        taxes: includeTaxes ? pretax * 0.13 : 0,
                        amount: totalPrice(),
                        aditional: aditional,
                      },
                      numberOfProducts: quantity,
                      aditionalData: {
                        productName: product.productName,
                        company: company,
                        connectorType:
                          product.type === "EV_STATION"
                            ? connectors[connectorType]
                            : null,
                        powerKw:
                          product.type === "EV_STATION"
                            ? powerKws[powerKw]
                            : null,
                        comMod:
                          product.type === "EV_STATION" ? "Sin asignar" : null,
                      },
                      annotations: annotations,
                      specifications: specifications,
                    },
                  ]);
                  setOpen(false);
                }}
              >
                Agregar al carrito
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </SwipeableDrawer>
  );
}
